import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/Admin/AdminLayout';
import DataTable from '../../components/Admin/DataTable';
import projectService from '../../services/projectService';

export default function CaseStudies() {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProjects = async () => {
        try {
            setLoading(true);
            const response = await projectService.getAllProjects();
            // Ensure we handle both structure formats: { success: true, data: [...] } or just [...]
            setProjects(response.data || response || []);
        } catch (err) {
            console.error('Error fetching projects:', err);
            setError('Failed to load projects');
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        fetchProjects();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this project?')) {
            try {
                await projectService.deleteProject(id);
                fetchProjects();
            } catch (err) {
                console.error('Error deleting project:', err);
                alert('Failed to delete project');
            }
        }
    };

    const handleEdit = (project) => {
        navigate(`/admin/case-studies/edit/${project.slug}`);
    };

    const columns = [
        {
            header: 'Project Name',
            accessor: 'title',
            render: (item) => (
                <div className="font-medium text-white">{item.title}</div>
            )
        },

        {
            header: 'Date',
            accessor: 'created_at',
            render: (item) => new Date(item.created_at).toLocaleDateString()
        }
    ];

    return (
        <AdminLayout>
            <div className="flex flex-col space-y-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 flex-none">
                    <div className="flex space-x-4 flex-1">
                        {/* Search */}
                        <div className="relative flex-1 max-w-md">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            </div>
                            <input
                                type="text"
                                placeholder="Search case studies..."
                                className="w-full pl-10 pr-4 py-2 bg-[#1a1025] border border-white/10 rounded-lg focus:outline-none focus:border-blue-500 text-gray-300 placeholder-gray-500"
                            />
                        </div>
                    </div>

                    <Link
                        to="/admin/case-studies/new"
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors shadow-lg"
                    >
                        Add New Case Study
                    </Link>
                </div>

                {error && (
                    <div className="mb-6 p-4 bg-red-500/10 border border-red-500/30 rounded-lg">
                        <p className="text-red-400">{error}</p>
                    </div>
                )}

                <div>
                    <DataTable
                        columns={columns}
                        data={projects}
                        isLoading={loading}
                        onEdit={handleEdit}
                        onDelete={(item) => handleDelete(item.id)}
                    />
                </div>
            </div>
        </AdminLayout>
    );
}
